import React from 'react'
import styled from 'styled-components'

import Badge from '../Badge'
import Icon from '../Icon'
import FeedbackRender, { TFeedbackRender } from './FeedbackRender'
import { TMeta } from './types'

const Wrapper = styled.div`
  margin-top: 5px;
`

const Text = styled.span`
  font-size: 1.15em;
`
type TFeedbackBadge = {
  meta?: TMeta
  children?: React.ReactNode
  alwaysDirty?: boolean
}

const FeedbackBadge = (props: TFeedbackBadge): React.ReactElement | null => {
  const { meta, children, alwaysDirty } = props

  const { dirtySinceLastSubmit, error, dirty, submitError, touched } =
    meta || {}

  let feedback: TFeedbackRender

  if (dirty || touched || alwaysDirty) {
    if (error || (submitError && !dirtySinceLastSubmit)) {
      feedback = children || error || submitError
    }
  }

  if (!feedback) {
    return null
  }

  return (
    <Wrapper>
      <Badge danger>
        <Icon icon="fas fa-exclamation-triangle" className="mr-1" />
        <Text>
          <FeedbackRender feedback={feedback} />
        </Text>
      </Badge>
    </Wrapper>
  )
}

export default FeedbackBadge
